import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useData } from '../../context/DataContext';
import { useAuth } from '../../context/AuthContext';
import ClientList from './ClientList';
import ClientModal from './ClientModal';
import ClientFilters from './ClientFilters';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiPlus } = FiIcons;

const ClientManagement = () => {
  const { clients } = useData();
  const { hasPermission } = useAuth();
  const [showModal, setShowModal] = useState(false);
  const [selectedClient, setSelectedClient] = useState(null);
  const [filters, setFilters] = useState({
    status: 'all',
    stage: 'all'
  });

  const filteredClients = clients.filter(client => {
    if (filters.status !== 'all' && client.status !== filters.status) return false;
    if (filters.stage !== 'all' && client.stage !== filters.stage) return false;
    return true;
  });

  const handleCreateClient = () => {
    setSelectedClient(null);
    setShowModal(true);
  };

  const handleEditClient = (client) => {
    setSelectedClient(client);
    setShowModal(true);
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold text-gray-900">Client Management</h1>
          <p className="text-gray-600 mt-1">
            Manage your clients and track the sales pipeline
          </p>
        </div>

        <motion.button
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
          onClick={handleCreateClient}
          className="flex items-center space-x-2 bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition-colors"
        >
          <SafeIcon icon={FiPlus} className="w-5 h-5" />
          <span>Add Client</span>
        </motion.button>
      </div>

      <ClientFilters filters={filters} onChange={setFilters} />

      <ClientList 
        clients={filteredClients}
        onEditClient={handleEditClient}
      />

      <AnimatePresence>
        {showModal && (
          <ClientModal
            client={selectedClient}
            onClose={() => setShowModal(false)}
          />
        )}
      </AnimatePresence>
    </div>
  );
};

export default ClientManagement;